import React, { useState, useEffect } from 'react';
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle';

import moment from 'moment';

import { ANONYMOUS_USER } from '../../../selectors/users';
import { willExpireSoon, EXPIRATION_TIME_BY_PLAN } from '../utils';

const REFRESH_TIMESTAMPS_IN_MS = 30 * 1000;

moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: '1 minute',
    mm: '%d minutes',
    h: '1 hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    w: '1 week',
    ww: '%d weeks',
    M: '1 month',
    MM: '%d months',
    y: '1 year',
    yy: '%d years',
  },
});

const DangerNotification = ({ message }) => (
  <div className="video-notification video-notification--danger">{message}</div>
);

export const VideoNotifications = ({ userTier, video }) => {
  const { date_added } = video;
  const expirationPeriod = EXPIRATION_TIME_BY_PLAN[userTier];

  const [, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, REFRESH_TIMESTAMPS_IN_MS);

    return () => clearInterval(interval);
  }, [date_added, userTier]);

  const momentDateAdded = moment(new Date(date_added * 1000));
  const isDateInFuture = momentDateAdded.isAfter();

  if (video.stale) {
    return <DangerNotification message="Pending Deletion" />;
  }

  if (userTier !== ANONYMOUS_USER || isDateInFuture) {
    return null;
  }

  if (willExpireSoon(date_added, userTier)) {
    const timeToExpire = momentDateAdded.add(expirationPeriod, 'h').fromNow();

    return (
      <div className="video-notification video-notification--warn">
        <FaExclamationTriangle />
        {`Expires ${timeToExpire}`}
      </div>
    );
  }
};
